export default "__VITE_ASSET__Dlnojdk3__"